;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { event } from '../utils/gtag';
import axiosInstance from '../utils/axios';

export const uploadGdprForm = async (app, body) => {
  const { data } = await axiosInstance.post(`/privacy`, body);

  event({
    action: 'gdpr request',
    category: app || 'synergiejobs.be',
    label: '',
    value: body,
  });

  return data;
};
